module.exports = __webpack_public_path__ + "img/horizontal_3_4_pp2_1.1e643c9a.png";